/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import ModeloTipoContribuyente from 'Infotrack@Modelos/administracion/tipoContribuyente';
import ITipoContribuyente from 'Infotrack@Modelos/administracion/tipoContribuyente/entidades/tipoContribuyente';

export default class ControladorModeloTipoContribuyente {
    private modeloTipoContribuyente: ModeloTipoContribuyente;
    constructor() {
        this.modeloTipoContribuyente = new ModeloTipoContribuyente();
    }

    public consultarTipoContribuyente() {
        return this.modeloTipoContribuyente.consultarTipoContribuyente().then(({ data: { Entidades } }) => Entidades);
    }

    public async crearTipoContribuyente(tipoContribuyente: ITipoContribuyente) {
        await this.modeloTipoContribuyente.crearTipoContribuyente(tipoContribuyente);
    }

    public async editarTipoContribuyente(tipoContribuyente: ITipoContribuyente) {
        await this.modeloTipoContribuyente.editarTipoContribuyente(tipoContribuyente);
    }

    public async eliminarTipoContribuyente(tipoContribuyente: ITipoContribuyente) {
        await this.modeloTipoContribuyente.eliminarTipoContribuyente(tipoContribuyente);
    }

    public validarEntidad(tipoContribuyente: ITipoContribuyente): boolean {
        if (tipoContribuyente.CodigoTipoContribuyente === '' || tipoContribuyente.NombreTipoContribuyente === '') {
            notificacionGlobal('comunes.alerta.camposIncompletos', 6000, 'warning', true);
            return false;
        }
        return true;
    }
}
